module.exports = __webpack_public_path__ + "static/media/archibeau_gisenyi1.267d2fad.jpg";